import { FormError } from '@classgo/app-kit';
import { Button } from '@classgo/ui';
import type { FormEvent, ReactNode } from 'react';

import { useT } from '../i18n';

/**
 * The frame of every academic form: the form-level error, the fields, the save button.
 */
export const FormShell = ({
  error,
  busy,
  onSubmit,
  children,
  submitLabel,
}: {
  error: string | null;
  busy: boolean;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  children: ReactNode;
  submitLabel?: string;
}) => {
  const t = useT();
  return (
    <form onSubmit={onSubmit} className="space-y-4" noValidate>
      <FormError message={error} />
      {children}
      <div className="flex justify-end pt-2">
        <Button type="submit" loading={busy}>
          {submitLabel ?? t('common.save')}
        </Button>
      </div>
    </form>
  );
};
